import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isEcomAdditionalInfo(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.ECOM_ADDITIONAL_INFO && typeof label === 'string' && typeof value === 'string';
}
function _formatEcomAdditionalInfo(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatEcomAdditionalInfo(submission) {
  if (isEcomAdditionalInfo(submission)) {
    return _formatEcomAdditionalInfo(submission);
  }
  return undefined;
}
//# sourceMappingURL=ecom-additional-info-preview.js.map